<!--
/**
* @name: Detail.vue
* @description: 门店陈列活动审核记录-详情页
* @author: 杨波
* @create: 2020/05/19 15:40:37
* @update: 2020/05/19 15:40:37
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-form title="基本信息" titleAlign="left" align="center" titleWidth="80px" contentWidth="400px">
      <y-query spaceBetween :hasSearchButton="false">
        <y-query-item>
          <y-form-item title="门店编码:">
            <div :class="css.inputW">{{ editPara.shopCode ? editPara.shopCode : "——" }}</div>
          </y-form-item>
        </y-query-item>
        <y-query-item>
          <y-form-item title="门店名称:">
            <div :class="css.inputW">{{ editPara.shopName ? editPara.shopName : "——" }}</div>
          </y-form-item>
        </y-query-item>
      </y-query>
      <y-query spaceBetween :hasSearchButton="false">
        <y-query-item>
          <y-form-item title="申请用户账号:">
            <div :class="css.inputW">{{ editPara.memberAccount ? editPara.memberAccount : "——" }}</div>
          </y-form-item>
        </y-query-item>
        <y-query-item>
          <y-form-item title="申请用户角色:">
            <div :class="css.inputW">{{ editPara.memberAccountTypeName ? editPara.memberAccountTypeName : "——" }}</div>
          </y-form-item>
        </y-query-item>
      </y-query>
      <y-query spaceBetween :hasSearchButton="false">
        <y-query-item>
          <y-form-item title="提交时间:">
            <div :class="css.inputW">{{ editPara.submitTime ? editPara.submitTime : "——" }}</div>
          </y-form-item>
        </y-query-item>
        <y-query-item>
          <y-form-item title="审核时间:">
            <div :class="css.inputW">{{ editPara.auditTime ? editPara.auditTime : "——" }}</div>
          </y-form-item>
        </y-query-item>
      </y-query>
    </y-form>
    <div class="spliter"></div>
    <y-form title="陈列信息" titleAlign="left" align="center" titleWidth="80px" contentWidth="400px">
      <y-form-item title="陈列图:" align="top">
        <div class="row">
          <y-image view v-dragging="{ list: editPara.displayImages, item: img, group: 'image' }" v-for="(img, index) in editPara.displayImages" :key="index" :index="index" :src="img"></y-image>
        </div>
      </y-form-item>
    </y-form>
    <!-- 审核拒绝确认弹窗区域 start -->
    <k-popup bind="v-if" okText="确认" title="审核拒绝" :show.sync="isShowPopup" @after-ok="onSave">
      <div style="width: 650px;">
        <y-form titleAlign="right" titleWidth="60px" contentWidth="400px">
          <y-form-item title="拒绝原因:" required align="top">
            <k-input tag="textarea" :class="css.textarea" placeholder="请输入拒绝原因，最多输入50个字" maxlength="50" block v-model="refuseReason" clearable></k-input>
          </y-form-item>
        </y-form>
      </div>
    </k-popup>
    <!-- 审核拒绝确认弹窗区域 end -->
    <div slot="bottom">
      <k-button @click="onCancel(true, false)">取消</k-button>
      <k-button type="primary" @click="handleLinkToRefusePopup" v-if="editPara.auditStatus === 'wait'">审核拒绝</k-button>
      <k-button type="primary" @click="handleLinkToAuditPass" v-if="editPara.auditStatus === 'wait'">审核通过</k-button>
    </div>
  </y-view>
</template>
<script>
import { NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_AUDIT, NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_DETAIL } from "@/assets/modules/apiList";
const initEditPara = () => ({
  id: "",
  auditStatus: "", //审核状态
  displayActivityId: "", //活动ID
  activityName: "", //活动名称
  shopCode: "", //门店编码
  shopName: "", //门店名称
  memberAccount: "", //申请用户账号
  memberAccountType: "", //申请用户角色类型
  memberAccountTypeName: "", //申请用户角色类型名称
  submitTime: "", //提交时间
  auditTime: "", //审核时间
  displayImages: "", //陈列图
});
export default {
  data() {
    return {
      isLoading: false,
      isSaving: false,
      isShowPopup: false,
      refuseReason: "",
      editPara: initEditPara(),
    };
  },
  filters: {},
  computed: {},
  watch: {},
  methods: {
    /** 获取门店陈列活动信息详情 */
    getActivityDetail(id) {
      this.isLoading = true;
      this.$fetch({ api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_DETAIL, para: { id: id } })
        .then(async (res) => {
          this.editPara = { ...this.editPara, ...res };
          this.editPara.displayImages = this.editPara.displayImages ? this.editPara.displayImages.split(",") : [];
          this.isLoading = false;
          this.$forceUpdate();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /** 返回门店陈列活动申请记录列表 */
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "applyManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
            id: this.editPara.displayActivityId ? this.editPara.displayActivityId : "",
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },

    /** 审核通过操作 */
    handleLinkToAuditPass() {
      this.$dialog({
        title: "提示",
        content: "是否确认审核通过当前门店陈列活动？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_AUDIT,
            para: { ids: [this.editPara.id], auditStatus: "passed" },
          })
            .then(() => {
              this.isLoading = false;
              this.$root.tip("操作成功", "success");
              this.onCancel(true, true);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    handleLinkToRefusePopup() {
      this.refuseReason = "";
      this.isShowPopup = true;
    },

    /** 审核拒绝确认操作 */
    onSave() {
      if (!this.refuseReason) {
        return this.$root.tip("请输入拒绝原因", "error");
      }
      this.$dialog({
        title: "提示",
        content: "是否确认审核拒绝当前门店陈列活动？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_AUDIT,
            para: { ids: [this.editPara.id], auditStatus: "refused", refuseReason: this.refuseReason },
          })
            .then(() => {
              this.isLoading = false;
              this.$root.tip("操作成功", "success");
              this.isShowPopup = false;
              this.onCancel(true, true);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
  },
  async created() {
    const { id } = this.$route.query;
    this.editPara = initEditPara();
    if (id) this.getActivityDetail(id);
  },

  beforeRouteUpdate(to, from, next) {
    const { id } = to.query;
    this.editPara = initEditPara();
    if (id) this.getActivityDetail(id);
    next();
  },
};
</script>
<style module="css" lang="postcss">
.inputW {
  width: 400px !important;
}

.textarea {
  width: 400px !important;
  height: 150px;
  & :global(.k-textarea) {
    height: 150px !important;
    resize: none;
  }
}
</style>
